import { useState } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { Icon } from '../core/Icon';

export interface AISuggestionProps {
    text: ReactNode;
    onAccept?: () => void;
    onDismiss?: () => void;
    /** Versão compacta, para dentro de card ou linha de tabela. */
    inline?: boolean;
    style?: CSSProperties;
}

/**
 * Sugestão da assistente. Sempre dispensável: sugestão que não se fecha deixa
 * de ser sugestão e passa a ser cobrança.
 */
export function AISuggestion({ text, onAccept, onDismiss, inline = false, style }: AISuggestionProps) {
    const [fechado, setFechado] = useState(false);
    if (fechado) return null;
    const fechar = () => { setFechado(true); onDismiss?.(); };
    return (
        <div
            /* `status` e não `alert`: a sugestão não interrompe o que a pessoa
               está fazendo — ela é anunciada quando houver pausa. */
            role="status"
            style={{
                display: 'flex', alignItems: 'center', gap: 9, padding: inline ? '6px 10px' : '10px 12px',
                background: 'var(--surface)', border: '1px solid var(--border-brand-soft)', borderRadius: 'var(--radius-md)',
                boxShadow: inline ? 'none' : 'var(--shadow-xs)', ...style,
            }}
        >
            <Icon name="sparkles" size={14} style={{ color: 'var(--text-brand)', flex: '0 0 auto' }} />
            <span style={{ flex: 1, minWidth: 0, fontSize: 13, lineHeight: '18px', color: 'var(--neutral-700)' }}>{text}</span>
            {onAccept && (
                <button type="button" onClick={onAccept} style={{ border: 0, background: 'transparent', cursor: 'pointer', fontFamily: 'var(--font-ui)', fontSize: 12.5, fontWeight: 600, color: 'var(--text-brand)', padding: '2px 4px' }}>
                    Aplicar
                </button>
            )}
            <button
                type="button" onClick={fechar} aria-label="Dispensar sugestão"
                style={{ border: 0, background: 'transparent', cursor: 'pointer', color: 'var(--neutral-500)', padding: 2, display: 'flex', flex: '0 0 auto' }}
            >
                <Icon name="x" size={14} />
            </button>
        </div>
    );
}
